export const contentTargetingGroups = [
  {
    name: _TL_('Microsoft Edge Browsers'),
    description: _TL_('Native ad placements on Microsoft Edge’s new tab page'),
    placementId: 12,
  },
  {
    name: _TL_('Productivity'),
    description: _TL_('Microsoft 365 (Native and Display ad placements) and Outlook (Native and Display ad placements)'),
    placementId: 13,
  },
  {
    name: _TL_('Gaming'),
    description: _TL_('Native, Display, and Video ad placements on Microsoft Casual Games'),
    placementId: 14,
  },
  {
    name: _TL_('MSN'),
    description: _TL_('Native, Display, and Video ad placements on MSN (serving with all available MSN content)'),
    placementId: 15,
  },
  // {
  //   name: _TL_('MSN - Sports'),
  //   description: _TL_('Native, Display, and Video ad placements serving exclusively with MSN sports-related content'),
  //   placementId: 3,
  // },
  {
    name: _TL_('MSN - Health'),
    description: _TL_('Native, Display, and Video ad placements serving exclusively with MSN health-related content'),
    placementId: 7,
  },
  {
    name: _TL_('MSN - Money'),
    description: _TL_('Native, Display, and Video ad placements serving exclusively with MSN money-related content'),
    placementId: 4,
  },
];
